import React from 'react';
import { DashboardAlert } from '../driverDashboardTypes';
import styles from './AlertsList.module.css';

interface AlertsListProps {
  alerts: DashboardAlert[];
}

const variantIcons: Record<DashboardAlert['variant'], React.ReactNode> = {
  error: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  ),
  warning: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" />
    </svg>
  ),
};

export const AlertsList: React.FC<AlertsListProps> = ({ alerts }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.headerIcon}>
          <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
        </svg>
        <h3 className={styles.title}>Alerts</h3>
      </div>
      <div className={styles.list}>
        {alerts.map((alert) => (
          <div key={alert.id} className={`${styles.alert} ${styles[alert.variant]}`}>
            <span className={styles.alertIcon}>{variantIcons[alert.variant]}</span>
            <div className={styles.alertContent}>
              <p className={styles.alertTitle}>{alert.title}</p>
              <p className={styles.alertDesc}>{alert.description}</p>
              <p className={styles.alertTime}>{alert.timeAgo}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
